import React, { PureComponent, PropTypes } from 'react';
import cx from 'classnames';

const HIGHLIGHTED = 'bg-color-mint-green color-text';

export default class EventAccountData extends PureComponent {
  static propTypes = {
    highlighted: PropTypes.bool
  };

  static defaultProps = {
    highlighted: false
  };

  render() {
    const { children, className, highlighted } = this.props;

    return (
      <span className={cx({ [ HIGHLIGHTED ]: highlighted }, className)}>
        {children}
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/event/EventAccountData.jsx